// ============================================================
// LA FACCIA DELLA MASCOTTE, in un posto solo.
//
// La stessa faccia serve alla schermata di caricamento e alla guida
// nell'angolo dello schermo. Tenerla scritta due volte voleva dire
// ritoccarne una e dimenticare l'altra — è già successo con le
// proporzioni quando esisteva anche la versione 3D.
//
// Le misure sono quelle della viewBox 220x220 con la palla di raggio 78
// centrata in (110, 110): occhi tondi da 28 a ±30 dal centro e 13 più in
// alto, pupille da 16 tre più in basso, bocca a corda 16 su raggio 13.
// OCCHI PIU' GRANDI E BOCCA PIU' PICCOLA (chiesto dall'utente, 2026-09-15):
// erano 25 / 14 / corda 22. CRESCENDO GLI OCCHI, VOLTANDO LA TESTA USCIVANO
// DALLA PALLA — calcolato su tutte le pose di `testa-gira`, con e senza lo
// spalancamento: gia' a raggio 27 si arrivava al 103% del raggio. Percio'
// insieme agli occhi sono calati il giro della testa (x0,75) e lo
// spalancamento (1,12 -> 1,08). Caso peggiore ora 97,1% (spalancati) e 91,7%
// (normali), contro 97,9% e 90,7% di prima. Cambiando uno di questi numeri,
// RIFARE il conto: a occhio non si vede finche' un giorno l'occhio non esce.
// Chi la usa disegna il CORPO per conto suo, perché nella schermata di
// caricamento la palla si rimpicciolisce fino a diventare un puntino e
// qui invece no.
//
// TUTTA LA VITA PASSA DALLO SGUARDO: è la misura presa sul riferimento
// (bloub), e qui i gruppi annidati servono proprio a sovrapporre più
// movimenti dell'occhio senza che si contendano la stessa trasformazione.
// QUANTO PUÒ VAGARE LA PUPILLA: raggio bianco 28 meno raggio pupilla 16
// = 12 di scarto. Lo scostamento massimo dei tre gruppi sommati, misurato,
// e' 9,05. Toccando un'ampiezza o un raggio, RIFARE questo conto, o la
// pupilla esce dall'occhio.
// ============================================================
export default function FacciaMascotte() {
  return (
    <g className="mascotte-faccia">
      {/* LA TESTA CHE SI VOLTA: occhi e bocca stanno in un gruppo solo, perché
          sono una TOPPA DIPINTA SU UNA PALLA. Girandosi non traslano soltanto:
          si stringono nel verso in cui vanno, come fa qualunque cosa disegnata
          su una sfera che ruota. È tutto qui il senso di profondità. */}
      <g className="mascotte-testa">
      <g className="mascotte-occhi">
        <circle className="occhio sx" cx="80" cy="97" r="28" />
        {/* il destro ha classe sua: e' quello che si chiude nell'occhiolino */}
        <circle className="occhio dx" cx="140" cy="97" r="28" />
        {/* Il gruppo più esterno è lo sguardo VOLONTARIO: guarda il punto
            esclamativo quando le spunta sopra la testa. Dentro, i due
            gruppi del vagare a vuoto, con periodi primi fra loro (11,3 s
            e 3,7 s) così la somma non si ripete a occhio. */}
        <g className="mascotte-sguardo-avviso">
          <g className="mascotte-sguardo-lento">
            <g className="mascotte-sguardo-svelto">
              <circle className="pupilla sx" cx="80" cy="100" r="16" />
              <circle className="pupilla dx" cx="140" cy="100" r="16" />
            </g>
          </g>
        </g>
      </g>
      {/* Le due bocche stanno in un gruppo perché si muovono INSIEME alla
          testa (vedi `testa-gira`): parlando, si alternano di opacità. */}
      <g className="mascotte-bocca-gruppo">
        {/* Sorriso appena accennato: corda 16 su raggio 13, cioè un arco
            ampio e poco profondo (affondo 2,75: la stessa curvatura di prima,
            solo piu' piccola). La curvatura all'ingiù la dà il flag di verso
            a 0. */}
        <path className="mascotte-bocca" d="M 102 139 A 13 13 0 0 0 118 139" />
        {/* La bocca aperta: stessa corda 16, ma piena e profonda 5,3.
            NON si ottiene schiacciando il sorriso — è una linea, e
            allungarla in verticale ne ingrasserebbe anche il tratto. */}
        <path className="mascotte-bocca-aperta" d="M 102 137 A 8.7 8.7 0 0 0 118 137 Z" />
      </g>
      </g>
    </g>
  )
}
